import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StarIcon } from '../icons/star.svg';

export default function MerryChristmasBanner() {
  const { t, i18n } = useTranslation();
  const { vs3424MerryChristmas } = useFlags();

  if (!vs3424MerryChristmas) return null;

  return (
    <div
      className='px-3 py-3 text-white mb-3 text-center d-flex flex-column align-items-center justify-content-center'
      style={{
        background: '#E53935',
        borderRadius: 8,
        border: '2px solid #F55F5B',
      }}
    >
      <StarIcon />
      <div
        className='my-2 Text--20 fw-800 multiline'
        style={{
          lineHeight: '24px',
        }}
      >
        {t('Merry Christmas and Happy New Year')}
      </div>
      <div className='mb-3'>
        {t(
          'We would be happy to hear your thoughts about our collaboration in 2022 to do better in 2023.'
        )}
      </div>
      <a
        className='Button--white'
        target='_blank'
        rel='noopener noreferrer'
        href={
          i18n.language === 'en'
            ? 'https://survey-eu1.hsforms.com/1TKsj8ygPQfinIdUZrg7r2gf10cm'
            : 'https://survey-eu1.hsforms.com/16qEUuN5FSFa_Zrtvyoo8ZAf10cm'
        }
      >
        {t("Let's go")}
      </a>
    </div>
  );
}
